import React from "react";
import { useAssetsPage } from "../../../store/AssetsProvider";
import {
  ASSET_QR_FIELDS,
  DEFAULT_ASSET_QR_FIELDS,
  TAssetQrField,
} from "../core/qr";

// Checkbox list of the details that can be encoded into a QR code. Writes
// straight to the shared (persisted) selection, so the single-asset preview,
// the per-row download and the bulk ZIP all stay in step.
export function AssetQrFieldsPicker() {
  const { qrFields, setQrFields } = useAssetsPage();

  const toggle = (key: TAssetQrField) => {
    const isOn = qrFields.includes(key);
    // Keep at least one field ticked so a QR never encodes an empty record.
    if (isOn && qrFields.length === 1) return;
    setQrFields(
      isOn
        ? qrFields.filter((k) => k !== key)
        : // Re-derive from ASSET_QR_FIELDS to keep the canonical line order.
          ASSET_QR_FIELDS.filter(
            (f) => f.key === key || qrFields.includes(f.key),
          ).map((f) => f.key),
    );
  };

  return (
    <div className="asset-qr-fields">
      {ASSET_QR_FIELDS.map((field) => (
        <label className="asset-qr-field" key={field.key}>
          <input
            type="checkbox"
            className="form-check-input"
            checked={qrFields.includes(field.key)}
            onChange={() => toggle(field.key)}
          />
          <span>{field.label}</span>
        </label>
      ))}
    </div>
  );
}

// Toolbar-launched modal so the selection can be changed before a bulk download
// without opening an individual asset first.
export default function AssetQrFieldsModal() {
  const { qrFields, setQrFields } = useAssetsPage();

  return (
    <div className="modal fade" id="kt_modal_asset_qr_fields" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered mw-600px">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="asset-modal-title">
              QR Code Contents
              <small className="text-muted">
                {qrFields.length} field{qrFields.length === 1 ? "" : "s"} selected
              </small>
            </h2>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <p className="asset-qr-fields-hint">
              Tick the details to encode into every QR code you generate. Empty
              values are skipped, and the asset number is always printed under
              the code on downloaded labels.
            </p>
            <AssetQrFieldsPicker />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => setQrFields([...DEFAULT_ASSET_QR_FIELDS])}
            >
              Reset to default
            </button>
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
